module.exports = __webpack_public_path__ + "img/second-day-1.d1a77776.webp";